import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ChartBase } from './chart-base';
import { ChartDisplayType } from './graph-tile/chart-tile-map.model';
import { ChartDataPoint, ChartSeriesDataPoint } from './models/chart-data-point.interface';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'qmg-chart-wrapper',
    templateUrl: './chart-wrapper.component.html',
    styleUrls: ['./chart-wrapper.component.scss'],
    standalone: false
})
export class ChartWrapperComponent<T extends ChartSeriesDataPoint | ChartDataPoint> extends ChartBase<T> {
   @Input() chartDisplayType: ChartDisplayType;
   @Input() displayPieGridIndividualPies: boolean;
   @Input() customLabel: String = 'Total';

   @Output() chartClick = new EventEmitter<ChartSeriesDataPoint>();

   ChartDisplayType = ChartDisplayType;

   onClick(data: ChartSeriesDataPoint) {
      this.chartClick.emit(data);
   }
}
